import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M7.83334 1.16665C7.83334 0.706409 7.46025 0.333313 7.00001 0.333313C6.53977 0.333313 6.16668 0.706409 6.16668 1.16665V6.16665H1.16668C0.70644 6.16665 0.333344 6.53974 0.333344 6.99998C0.333344 7.46022 0.70644 7.83331 1.16668 7.83331H6.16668V12.8333C6.16668 13.2936 6.53977 13.6666 7.00001 13.6666C7.46025 13.6666 7.83334 13.2936 7.83334 12.8333V7.83331H12.8333C13.2936 7.83331 13.6667 7.46022 13.6667 6.99998C13.6667 6.53974 13.2936 6.16665 12.8333 6.16665H7.83334V1.16665Z" })
});
export default SvgPlus;
